import React from "react";
import EventUserAvailabilityIndicator from "./EventUserAvailabilityIndicator";

export default function EventUserProfilePicture({
  eventUser: {
    user: { firstName, lastName },
    profilePictureSmall,
  },
  availability,
  hasAvailability = true,
}) {
  function getInitials() {

    if (firstName && lastName) {
      return `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`;
    }
  }
  return (
    <div className="event-user-profile-picture">
      <div
        className="event-user-profile-picture__picture"
        style={{
          backgroundImage: profilePictureSmall
            ? `url(${profilePictureSmall})`
            : "",
        }}
      >
        {!profilePictureSmall && (
          <p className="event-user-profile-picture__picture__initials m-0 p-0">
            {getInitials()}
          </p>
        )}
      </div>
      {hasAvailability && (
        <EventUserAvailabilityIndicator availability={availability} />
      )}
    </div>
  );
}
